<template>
    <div>
        <div class="bottom-line">
            <img :src="path+('bottom-line.png')">
        </div>
        <!--首頁-->
        <div class="index-bg">
            <div class="bottombg"></div>
            <div class="header-title">
                <img :src="path+('img-slogan.png')">
            </div>
            <div class="kv-area">
                <img :src="path+('img-logotype.png')">
            </div>
            <div class="flex-center">
                <a href="javascript:void ('')" class="btn-go" v-on:click="start">
                    <img :src="path+('img-btn1.png')">
                </a>
            </div>
            <div class="bottom-logo">
                <div class="btlogo">
                    <img :src="path+('img-logo.png')">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {gsap} from "gsap";
export default {
    props: ["path"],
    name:"Home",
    methods: {
        start(){
            let _this = this
            gsap.to('.index-bg', {opacity:0, duration:.5, onComplete:function () {
                    _this.$emit('switch-component', 'first-test')
                }})
        }
    },
    mounted() {
    }
}
</script>

